import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { EquipmentInfo } from 'pages/inventoryManagement/EquipmentInfo'
import { z } from 'zod'

const equipmentSearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
})

export const Route = createFileRoute('/equipment/$equipmentID')({
  component: EquipmentInfo,
  validateSearch: zodValidator(equipmentSearchParams),
})
